import * as FormValidation from 'formvalidation';
import Bootstrap from 'formvalidation/dist/es6/plugins/Bootstrap';

$(document).ready(function () {
    const form = document.getElementById('comparator_form');
    if (form !== null) {
        FormValidation.formValidation(form, {
            fields: {
                'comparator_email[email]': {
                    validators: {
                        notEmpty: {
                            message: "Adresse email obligatoire."
                        },
                        emailAddress: {
                            message: "Adresse email invalide."
                        }
                    }
                }
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new Bootstrap(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                /*icon: new FormValidation.plugins.Icon({
                    valid: 'fa fa-check',
                    invalid: 'fa fa-times',
                    validating: 'fa fa-refresh'
                }),*/ //Avec Bootstrap 4, ne pas oublier d'importer une fontIcons
                // declarative
                //declarative: new FormValidation.plugins.Declarative()
            }
        });
    }
});


export default function comparator() {

    var Cookies = require('js-cookie');

    var maxVehicleInComparator = 3;

    $(document).ready(function () {
        initComparatorButtons();
        initComparatorCounter();
    });

    var initComparatorButtons = function() {

        $('[data-comparator-vehicle]').each(
            function() {
                var vehicleId = $(this).attr('data-comparator-vehicle');

                if( vehicleId != '' && $(this).attr('data-comparator-initialized') == undefined) {
                    $(this).on('click', function () {
                        toggleVehicleComparator(vehicleId);
                        refreshVehicleButtonState($(this));
                    });

                    refreshVehicleButtonState($(this));

                    $(this).attr('data-comparator-initialized', true);
                }
            }
        );

        $('[data-comparator-remove-vehicle]').each(
            function() {
                var vehicleId = $(this).attr('data-comparator-remove-vehicle');

                if( vehicleId != '' && $(this).attr('data-comparator-initialized') == undefined) {
                    $(this).on('click', function () {
                        toggleVehicleComparator(vehicleId);
                        location.reload();
                    });

                    $(this).attr('data-comparator-initialized', true);
                }
            }
        );
    }

    var initComparatorCounter = function() {
        $( document ).on( "comparator-list-updated", function() {
            refreshCounter();
        });

        refreshCounter();
    }

    var refreshCounter = function() {
        var comparatorVehicles = getComparatorVehicleList();

        $('[data-comparator-counter]').text(comparatorVehicles.length);
    }

    var toggleVehicleComparator = function(vehicleId) {
        var comparatorVehicles = getComparatorVehicleList();

        if (comparatorVehicles.indexOf(vehicleId) === -1) {
            if(comparatorVehicles.length >= maxVehicleInComparator) {
                alert('Vous ne pouvez pas ajouter plus de '+maxVehicleInComparator+' véhicules au comparateur. \n Vous devez en supprimer un pour ajouter celui-ci.')
            } else {
                comparatorVehicles.push(vehicleId);
            }
        } else {
            var indexVehicle = comparatorVehicles.indexOf(vehicleId);

            if (indexVehicle !== -1) {
                comparatorVehicles.splice(indexVehicle, 1);
            }
        }

        Cookies.set('comparator_vehicles', comparatorVehicles);

        $( document ).trigger("comparator-list-updated");
    }

    var getComparatorVehicleList = function () {
        var comparatorVehicles = Cookies.getJSON('comparator_vehicles');

        if (comparatorVehicles == undefined) {
            comparatorVehicles = [];
        }

        return comparatorVehicles;
    }

    var refreshVehicleButtonState = function(buttonElem) {
        var vehicleId = $(buttonElem).attr('data-comparator-vehicle');
        var comparatorVehicles = getComparatorVehicleList();

        if (comparatorVehicles.indexOf(vehicleId) === -1) {
            $(buttonElem)
                .removeClass('selected');
        } else {
            $(buttonElem)
                .addClass('selected');
        }
    }

    global.initComparatorButtons = initComparatorButtons;
}


// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/vehicle/comparator.js